module.exports = __webpack_public_path__ + "img/sd-b-b-1.e2f3b5ae.jpg";